import { uploadBytes, ref } from 'firebase/storage';
import { firebase_storage } from '../firebase.config';

export async function uploadStorage(fileName: string, fileContent: File) {
  const fileRef = ref(firebase_storage, fileName);
  return uploadBytes(fileRef, fileContent);
}
